<template>
  <app-layout>
     <Head title="Lists"/>
    <template #header>
      <div class="md:flex justify-between items-center pb-1">
        <div class="mr-4 md:mr-5 flex justify-start items-center">
          <PageBackHeader
            :href="'/groups/view/' + group.group.tra_id"
            label="List"
            :subtitle="group.group.title + ': Edit'"
          />
        </div>
      </div>
    </template>

    <div class="max-w-7xl mx-auto flex mb-6">
      <div class="w-full p-2 sm:px-6 lg:px-8">
        <jet-form-section @submitted="updateListDetails">
          <template #title>
            List Details
          </template>

          <template #description>
            Update this List's information.
          </template>

          <template #form>
            <!-- Title -->
            <div class="col-span-6 sm:col-span-4">
              <jet-label for="title" value="List Title" />
              <jet-input
                id="title"
                type="text"
                class="mt-1 block w-full"
                v-model="form.title"
                autocomplete="off"
                maxlength="150"
                required
              />
              <p
                v-if="$page.props.errors.title"
                class="text-sm text-red-500"
              >
                {{ $page.props.errors.title }}
              </p>
              <jet-input-error v-if="form.errors.updateContactDetails" :message="form.errors.updateContactDetails.title" class="mt-2" />
            </div>

            <!-- Description -->
            <div class="col-span-6 sm:col-span-4">
              <jet-label for="description" value="Description" />
              <textarea
                v-model="form.description"
                name="description"
                placeholder="A quick description of the list"
                class="mb-3 w-full"
                required
              />
              <p
                v-if="$page.props.errors.description"
                class="text-sm text-red-500"
              >
                {{ $page.props.errors.description }}
              </p>
               <jet-input-error v-if="form.errors.updateContactDetails" :message="form.errors.updateContactDetails.description" class="mt-2" />
            </div>
          </template>

          <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
              Saved.
            </jet-action-message>
             <button class="mr-4">
              <Link :href="'/groups/view/' + group.group.tra_id" >
                Cancel
              </Link>
            </button>
            <jet-button
              :class="{ 'opacity-25': form.processing }"
              :disabled="form.processing"
            >
              Save
            </jet-button>
          </template>
        </jet-form-section>
      </div>
    </div>
  </app-layout>
</template>

<script>
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

export default {
  components: {
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    JetSecondaryButton,
  },

  props: {
    links: Object,
    group: Object
  },

  data() {
    return {
      form: this.$inertia.form(
        {
          title: this.group.group.title,
          description: this.group.group.description
        }
      )
    };
  },

  methods: {
    updateListDetails() {
      this.form.post(
        route("groups.edit.submit.json", {
          traId: this.group.group.tra_id,
        }),
        {
          onError: errors => {
            this.$toasted.show(
              `There's been an error updating the list, please try again.`,
              {
                position: "bottom-right",
                type: "error",
                duration: 1000
              }
            );
          }
        },
        {
          bag: "updateListInformation",
          resetOnSuccess: false
        }
      );
    },
  }
};
</script>
